const config = {
    API_URL_FOR_LOCAL_DEVELOPMENT: window.sanoLiving_globals.api_url,
    LANGUAGE: window.sanoLiving_globals.language,
    SESSION: window.sanoLiving_globals.session,
}

export default config;